const customBrandingKeys = {
  LOGO: "LOGO",
  ACCOUNT_NUM_REGEX: "ACCTNB_REGEX",
  ACCOUNT_NUM_HELP_TEXT: "ACCTNB_TOOLTIP",
  SSN_HELP_TEXT: "SSN_TOOLITP",
  ACCOUNT_VALIDATION_MSG: "ACCTNB_VAL_MSG",
  CMC_LOGO: "LOGO",
  STATEMENT_IMG: "ENROLL_LOGO"
}

const buildCustomBrandingObj = (list) => {
  if (list && list.length > 0) {
    return list.reduce((obj, cur) => {
      obj[cur.keyName] = cur.keyValue;
      return obj;
    }, {});
  }
  return null;
};

const getAllPopoverText = (list) => {
  if (list && list.length > 0) {
    return list.reduce((obj, cur) => {
      if (cur.keyName.indexOf("_TOOLTIP") > 0) {
        obj[cur.keyName] = cur.keyValue;
      }
      return obj;
    }, {});
  }
  return null;
};

const getCustomBrandingByKey = (key, list) => {
  let result;
  if (list && list.length > 0) {
    result = list.find((option) => {
      return option.keyName === key;
    });
  }

  if (result && result.hasOwnProperty("keyValue")) {
    return result.keyValue;
  }

  return null;
};

module.exports = {
  KEYS: customBrandingKeys,
  getCustomBrandingByKey: getCustomBrandingByKey,
  getAllPopoverText: getAllPopoverText
}
